export const cooperationStates = {
    active: "Active",
    pending: "Pending",
};
